import Desktop from '@/components/Desktop'

export default function HomePage() {
  return <Desktop />
}
